import { Component } from '@angular/core';

@Component({
    selector: 'body',
    template: '<router-outlet></router-outlet><ng2-toasty [position]="\'top-right\'"></ng2-toasty>'
})
export class AppComponent { }



// WEBPACK FOOTER //
// ./src/app/app.component.ts